module.exports = __webpack_public_path__ + "static/subway-ed716e86a61d1910fe93a5ac3fc990a4.png";